let container;

function init() {
  // Create a container on the <body> for all overlaid elements
  container = document.createElement('div');
  container.className = 'dv-overlay';
  document.body.appendChild(container);
  return container;
}

// Add an element to the container
export function add(el, owner) {
  if (!container) init();

  if (el instanceof HTMLElement) {
    if (typeof owner !== 'undefined') {
      el.setAttribute('data-owner', owner);
    }
    container.appendChild(el);
  }
}

// Remove an element from the container
export function remove(el) {
  if (container && el instanceof HTMLElement && el.parentNode === container) {
    container.removeChild(el);
  }
}

// Remove elements with the given owner
export function removeAllByOwner(owner) {
  if (!container) return;

  [...container.children].forEach((el) => {
    if (el.getAttribute('data-owner') === owner) {
      remove(el);
    }
  });
}

// Remove all elements from the container
export function clear() {
  if (container) {
    while (container.firstChild) {
      container.removeChild(container.firstChild);
    }
  }
}
